// When the public storefront is enabled (dev, for Paddle's review), surface in-app
// Pricing + legal links from the login page so reviewers landing on "/" can find them.
// Otherwise keep the external kolega.dev links.
const showPublicPages = process.env.REACT_APP_SHOW_PUBLIC_PAGES === 'true';

const footerLinks: { label: string; href: string; external: boolean }[] = showPublicPages
  ? [
      { label: 'Pricing', href: '/pricing', external: false },
      { label: 'Terms of Service', href: '/terms', external: false },
      { label: 'Privacy Policy', href: '/privacy', external: false },
      { label: 'Refund Policy', href: '/refund', external: false },
      { label: 'Contact', href: '/contact', external: false },
      { label: 'Status', href: 'https://status.kolega.dev', external: true },
    ]
  : [
      { label: 'Terms of Service', href: 'https://kolega.dev/terms', external: true },
      { label: 'Privacy Policy', href: 'https://kolega.dev/privacy', external: true },
      { label: 'Responsible Disclosure', href: 'https://kolega.dev/responsible-disclosure', external: true },
      { label: 'Status', href: 'https://status.kolega.dev', external: true },
    ];

const AuthFooter = () => {
  return (
    <footer role="contentinfo" className="border-t border-ui-border-primary dark:border-[#2A2A2A] py-8 bg-ui-background-tertiary dark:bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-ui-text-tertiary dark:text-[#666666]">
          <p className="text-sm mb-3">
            &copy; {new Date().getFullYear()} Kolega.dev. The Code Remediation Engine.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="text-ui-text-tertiary dark:text-[#808080] hover:text-lime-600 dark:hover:text-[#ADDD30] transition-colors underline py-2 px-1"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AuthFooter;
